import {
  NhanVienEntity,
  PhongBanEntity,
  WorkingEquipmentEntity,
} from '../../../../../server-api-hrm.type'
import { BASE_URL } from '../../../../../utils/config.base-url'

export const WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL = '/phieu-phan-bo'
export const WORKING_EQUIPMENT_ALLOCATION_WAITING_APPROVE_PREFIX_URL = `${WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL}/waiting-approve`
export const WORKING_EQUIPMENT_ALLOCATION_MY_APPROVE_PREFIX_URL = `${WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL}/my-approve`
export const WORKING_EQUIPMENT_ALLOCATION_APPROVED_PREFIX_URL = `${WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL}/approved`
export const WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL = `${WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL}/report`

export const URL_ENDPOINT_WORKING_EQUIPMENT_ALLOCATION = `${BASE_URL}/working-equipment-allocation`
export const URL_ENDPOINT_WORKING_EQUIPMENT_ALLOCATION_APPROVAL_LOG = `${BASE_URL}/working-equipment-allocation-approval-log/list/by-working-equipment-allocation`

export interface ReportDataByResource {
  id: string
  rec: WorkingEquipmentEntity
  requestCount: number
  allocatedCount: number
  unAllocatedCount: number
  percentAllocated: number
}

export type ReportNodeByPhongBan =
  | {
      id: string
      isParent: true
      rec: PhongBanEntity
      requestCount: number
      allocatedCount: number
      unAllocatedCount: number
      percentAllocated: number
      totalPercent: number
      children: (ReportNodeByPhongBan & { isParent: false })[]
    }
  | {
      id: string
      isParent: false
      rec: NhanVienEntity
      requestCount: number
      allocatedCount: number
      unAllocatedCount: number
      percentAllocated: number
      children?: undefined
    }

export type ReportDataByPhongBan = ReportNodeByPhongBan & { isParent: true }
